module.exports = __webpack_public_path__ + "img/stream.9358c90c.svg";